import { GetConfiguration } from "../utils/config";
import Auth, { AuthDataType} from '../types/auth';
import { User } from 'oidc-client';
import { getHeadersForSSO, handleErrorsForSSO } from './identityService';
import { PrincipalWhatsNew } from '../models/principalWhatsNew';

export const insertPrincipalWhatsNew = (ip: string, authData: AuthDataType, user: User, model: PrincipalWhatsNew): Promise<PrincipalWhatsNew> => {
        
    // let body = EntityUtils.isEntity(model) ? EntityUtils.asJSON(model) : JSON.stringify(model);
    console.log('Insert PrincipalWhatsNew con oggetto: ', + JSON.stringify(model));
    const url = `${GetConfiguration().api_url}/principalwhatsnew`
    console.log('Insert PrincipalWhatsNew', url);
    return window.fetch(url, {
        method: 'POST',
        headers: getHeadersForSSO(ip, user),
        body: JSON.stringify(model)
    })
        .then(res => handleErrorsForSSO(res))
        .then(res => res.json())
        .then(json => {
            console.log(`PrincipalWhatsNew ("${authData.user}") -> letti ${json.length} pauth`);
            console.log('PrincipalWhatsNew recuperata json: ' + JSON.stringify(json));
            const rv = (json as PrincipalWhatsNew);
            console.log('PrincipalWhatsNew recuperata principalauth: ' + JSON.stringify(rv));
            return rv;
        })
        .catch(error => {
            console.log('PrincipalWhatsNew error:', error);
            throw error;
        });
}
